import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

type ButtonTheme = 'primary' | 'secondary' | 'basic' | 'danger' | 'dark';
type IconPosition = 'left' | 'right';

/**
 * Component for Call-To-Action buttons with customizable theme, icon, and position.
 */
@Component({
  selector: 'cta-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cta-button.component.html',
  styleUrl: './cta-button.component.css'
})
export class CtaButtonComponent {
  @Input() text: string = '';
  @Input() icon: string = '';
  @Input() theme: ButtonTheme = 'basic';
  @Input() disabled: boolean = false;
  @Input() iconPosition: IconPosition = 'right';
  @Input() width: string = 'auto';
  @Output() buttonClick = new EventEmitter<void>();

  themeClassMap: Record<string, string> = {
    primary: 'primaryTheme',
    secondary: 'secondaryTheme',
    danger: 'dangerTheme',
    basic: 'basicTheme',
    dark: 'darkTheme',
  };

  /**
   * Returns the CSS class based on the current theme.
   */
  get themeClass(): string {
    return this.themeClassMap[this.theme] || 'basicTheme';
  }

  /**
   * Handles button click event.
   */
  onClick() {
    if (!this.disabled) {
      this.buttonClick.emit();
    }
  }
}
